import { PopoverButton } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import ActiveFiltersBadge from '@/pages/lobby/components/ActiveFiltersBadge';
import { SettingsIcon } from 'lucide-react';
import useIsMobileView from '@/hooks/useIsMobileView';
import { FC } from 'react';

interface FilterButtonProps {
  numberOfFilters?: number;
}
const FiltersButton: FC<FilterButtonProps> = ({ numberOfFilters }) => {
  const isMobileView = useIsMobileView();

  return (
    <PopoverButton
      className={twMerge(
        isMobileView
          ? 'flex h-11 w-11 items-center justify-center rounded-lg bg-ph-primary-violet p-2.5 font-bold text-white'
          : 'flex h-11 select-none items-center gap-2 rounded-lg bg-ph-violet-light px-7 font-bold tracking-wide text-ph-gray-silver hover:bg-ph-gray-baltic',
      )}
    >
      <SettingsIcon className="h-6 w-6" />
      {!isMobileView && <span className="text-sm text-ph-gray-silver">Filters</span>}

      {!!numberOfFilters && !isMobileView && <ActiveFiltersBadge numberOfFilters={numberOfFilters} />}
    </PopoverButton>
  );
};

export default FiltersButton;
